import { AccessTimeOutlined } from '@mui/icons-material';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent, { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import { Chip, Typography } from '@mui/material';

import { CustomAccordion } from '../../../components/CustomAccordion';
import { type Veranstaltung } from '../../../dtos';

type VeranstaltungsAblaufProps = {
  readonly veranstaltung: Veranstaltung;
};

export const VeranstaltungsAblaufComponent = ({ veranstaltung }: VeranstaltungsAblaufProps) => (
  <CustomAccordion title="Zeitlicher Ablauf" icon={AccessTimeOutlined}>
    {veranstaltung.ablauf.length === 1 ? (
      <Typography variant="paragraphSm">1. Termin</Typography>
    ) : (
      <Typography variant="paragraphSm">{veranstaltung.ablauf.length}. Termine</Typography>
    )}
    <Timeline>
      {veranstaltung.ablauf.map((block, idx) => {
        const start = new Date(block.starttime);
        const end = new Date(block.endtime);
        const now = new Date();

        return (
          <TimelineItem
            key={veranstaltung.id}
            sx={{
              [`& .${timelineOppositeContentClasses.root}`]: {
                flex: 0.2,
              },
            }}
          >
            <TimelineOppositeContent flex="0.2" />
            <TimelineSeparator>
              {start < now ? <TimelineDot color="success" /> : <TimelineDot />}
              {idx + 1 !== veranstaltung.ablauf.length && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent>
              <Chip
                label={start.toLocaleDateString('de-GE', {
                  weekday: 'short',
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                })}
              />{' '}
              {start.toLocaleTimeString('de-GE', { hour: '2-digit', minute: '2-digit' })} -{' '}
              {end.toLocaleTimeString('de-GE', { hour: '2-digit', minute: '2-digit' })}
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  </CustomAccordion>
);
